/**
 * Regras do score de saúde financeira — FONTE ÚNICA.
 *
 * A ficha do beneficiário (painel completo + legenda) e a busca (alerta na
 * lista) leem daqui. Duplicar essas faixas nos dois lugares faria a legenda
 * dizer uma coisa e a busca pintar outra — foi por isso que virou módulo.
 *
 * A COR sai da FAIXA DE ATRASO (piso), não só da aritmética: um caso de 61 dias
 * nunca exibe amarelo por acaso, mesmo que os outros fatores somem.
 */

export const FAIXAS_ATRASO = [
  { min: 61, peso: -70, nivel: 3, rotulo: 'CRÍTICO', cor: '#ef4444', texto: 'acima de 60 dias' },
  { min: 40, peso: -40, nivel: 2, rotulo: 'ATENÇÃO', cor: '#eab308', texto: '40 a 60 dias' },
  { min: 1,  peso: -15, nivel: 1, rotulo: 'REGULAR', cor: '#22c55e', texto: '1 a 39 dias' },
  { min: 0,  peso: 0,   nivel: 0, rotulo: 'REGULAR', cor: '#22c55e', texto: 'sem atraso' },
];

export const faixaDoAtraso = (dias) =>
  FAIXAS_ATRASO.find((f) => (dias || 0) >= f.min) || FAIXAS_ATRASO[FAIXAS_ATRASO.length - 1];

export const PESO_DEPENDENTE = -3;
export const PESO_CONTRATO_SUBORDINADO = -5;
export const PESO_CARENCIA = -7;

/**
 * Mensalidade em atraso enseja cancelamento; coparticipação, não.
 * Tratar as duas igual induz o atendente ao erro (caso real: titular com 60+
 * dias só de coparticipação, que NÃO pode ser cancelado).
 */
export const ehMensalidade = (t) => /mensalidade/i.test(t || '');

/** Frase da consequência contratual, só quando o atraso já passou de 60 dias. */
export function consequenciaContratual(dias, temMensalidade) {
  if ((dias || 0) < 61) return '';
  return temMensalidade
    ? ' (mensalidade: enseja cancelamento contratual)'
    : ' (coparticipação: não enseja cancelamento)';
}
